import config from '../../config';
import MPUtils from '../../utils/MPUtils';

let dataManager;
let soundManager;

class PowerUpButton {
  constructor (game, x, y, powerUpType) {
    let g = game;
    if (!soundManager) {
      soundManager = g.scene.get('SoundManager');
      dataManager = g.sys.game.dataManager;
    }
    this.g = g;
    this.x = x;
    this.y = y;
    this.type = powerUpType;
    this.adActive = false;
    this.overlay = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'overlay');
    this.overlay.setAlpha(0);
    this.overlay.on('pointerdown', this.closeCostBubble, this);
    this.shadow = g.add.sprite(x, y + 114, 'play-sprite');
    this.shadow.setFrame(`shadow-${powerUpType}.png`);
    this.sprite = g.add.sprite(x, y, 'play-sprite');
    this.sprite.setFrame(`btn-${powerUpType}.png`);
    this.iconGray = g.add.sprite(x - 5, y + 25, 'play-sprite');
    this.iconGray.setFrame(`${powerUpType}-gray.png`);
    this.iconRed = g.add.sprite(x - 5, y + 25, 'play-sprite');
    this.iconRed.setFrame(`${powerUpType}-red.png`);
    this.iconRed.setAlpha(0);
    this.iconGreen = g.add.sprite(x - 5, y + 25, 'play-sprite');
    this.iconGreen.setFrame(`${powerUpType}-grn.png`);
    this.iconGreen.setAlpha(0);
    this.active = false;

    // cost bubble
    this.bubble = g.add.sprite(x, y - 200, 'play-sprite');
    this.bubble.setFrame('bubble-speach.png');
    this.bubble.setScale(0);

    this.title = g.add.text(this.bubble.x, this.bubble.y - 75, g.sys.game.localisationManager.GetString(powerUpType), { fontFamily: '"FredBurger Black"', fontSize: 64 +"px", color: "#db433e" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(this.title, 230, 500);
    this.cost = config.COST[powerUpType];

    this.coinText = g.add.text(this.bubble.x, this.bubble.y - 22, this.cost, { fontFamily: '"FredBurger Black"', fontSize: 48 +"px", color: "#f8df1d" }).setOrigin(0.5).setStroke('#000', 3)

    this.coin = g.add.sprite(this.bubble.x - this.coinText.width / 2 + 10, this.coinText.y, 'play-sprite');
    this.coin.setFrame('coin.png');
    this.coin.setOrigin(1, 0.5);
    this.confirm = g.add.sprite(this.bubble.x + 35, this.bubble.y + 34, 'play-sprite');
    this.confirm.setFrame('confirm.png');
    this.confirm.on('pointerdown', this.purchasePowerUp, this);
    this.close = g.add.sprite(this.bubble.x - 35, this.bubble.y + 34, 'play-sprite');
    this.close.setFrame('close.png');
    this.close.originX = this.close.x;
    this.close.on('pointerdown', this.closeCostBubble, this);
    this.bearGroup = [this.sprite, this.iconGray, this.iconRed, this.iconGreen, this.bubble];
    this.bubbleGroup = [this.title, this.coinText, this.coinText, this.coin, this.confirm, this.close];
    _.each(this.bubbleGroup, (sprite) => {
      sprite.setAlpha(0);
    });

    this.sprite.setInteractive();
    this.sprite.on('pointerdown', this.onBearClick, this);
  }
  setCost (c) {
    this.cost = c;
    this.coinText.setText(this.cost);
    this.coin.setX(this.bubble.x - this.coinText.width / 2 + 10);
  }
  setAdActive (bool) {
    let g = this.g;
    this.adActive = bool;
  }
  onBearClick () {
    if (!this.active) {
      return;
    }

    this.showCostBubble();
    
    soundManager.playSound('button-press');
  }
  
  showCostBubble () {
    let g = this.g;
    if (this.cost > dataManager.getCoins()) {
      this.hideConfirm();
    } else {
      this.showConfirm();
    }
    this.sprite.removeAllListeners();
    this.sprite.setFrame(`btn-${this.type}-active.png`);
    g.children.bringToTop(this.overlay);
    g.children.bringToTop(g.ui.coin);
    g.children.bringToTop(g.ui.coinText);
    _.each(this.bearGroup, (sprite) => {
      g.children.bringToTop(sprite);
    });
    _.each(this.bubbleGroup, (sprite) => {
      g.children.bringToTop(sprite);
    });
    if (this.overlay.tween) {
      this.overlay.tween.stop();
    }
    if (this.bubble.tween) {
      this.bubble.tween.stop();
    }
    if (this.bubbleGroupTween) {
      this.bubbleGroupTween.stop();
    }
    this.overlay.tween = g.tweens.add({
      targets: this.overlay,
      alpha: 0.5,
      duration: 250
    });
    this.bubble.setScale(0);
    this.bubble.setAlpha(1);
    this.bubble.tween = g.tweens.add({
      targets: this.bubble,
      scaleX: 1,
      scaleY: 1,
      duration: 300,
      ease: 'Back.easeOut'
    });
    this.bubbleGroupTween = g.tweens.add({
      targets: this.bubbleGroup,
      alpha: 1,
      duration: 250,
      delay: 50
    });
    this.overlay.setInteractive();
    this.bubble.setInteractive();
    this.confirm.setInteractive();
    this.close.setInteractive();
  }
  closeCostBubble () {
    let g = this.g;
    this.overlay.removeInteractive();
    this.bubble.removeInteractive();
    this.confirm.removeInteractive();
    this.close.removeInteractive();
    this.sprite.setFrame(`btn-${this.type}.png`);
    this.overlay.tween = g.tweens.add({
      targets: this.overlay,
      alpha: 0,
      duration: 100
    });
    this.bubble.tween = g.tweens.add({
      targets: this.bubble,
      alpha: 0,
      duration: 100
    });
    this.bubbleGroupTween = g.tweens.add({
      targets: this.bubbleGroup,
      alpha: 0,
      duration: 100
    });
    this.sprite.on('pointerdown', this.onBearClick, this);
    soundManager.playSound('button-press');
  }
  purchasePowerUp () {
    let g = this.g;
    let coins = dataManager.getCoins();
    if (this.cost > coins) {
      console.warn('confirm button button should not be active');
      return;
    }
    dataManager.setCoins(coins - this.cost);
    g.powerUpUsed = true;
    this.onPurchase();
    this.closeCostBubble();
  }
  purchaseFeedback () {
    let g = this.g;
    this.iconGreen.setAlpha(1);
    this.tween = g.tweens.add({
      targets: this.iconGreen,
      alpha: 0,
      duration: 1000,
      delay: 100
    });
    if (this.adActive) {
      g.changeAdButton();
    }
  }
  purchaseFeedbackDisable () {
    let g = this.g;
    this.active = false;
    this.iconRed.setAlpha(0);
    this.iconGreen.setAlpha(1);
    this.tween = g.tweens.add({
      targets: this.iconGreen,
      alpha: 0,
      duration: 1000,
      delay: 100
    });
    if (this.adActive) {
      g.changeAdButton();
    }
  }
  hideConfirm () {
    let g = this.g;
    this.confirm.setActive(false);
    this.confirm.setVisible(false);
    this.close.x = this.bubble.x;
  }
  showConfirm () {
    let g = this.g;
    this.confirm.setActive(true);
    this.confirm.setVisible(true);
    this.close.x = this.close.originX;
  }
  setActive (bool) {
    let g = this.g;
    if (this.active === bool) {
      return;
    }
    if (this.tween) {
      this.tween.stop();
    }
    this.active = bool;
    if (this.active) {
      this.tween = g.tweens.add({
        targets: this.iconRed,
        alpha: 1,
        ease: 250
      });
    } else {
      this.tween = g.tweens.add({
        targets: this.iconRed,
        alpha: 0,
        ease: 250
      });
    }
  }
}

export default PowerUpButton;
